module.exports = __webpack_public_path__ + "media/images/tbrn-header-7e00e511c7fa2c928b47e6ada9366516.png";